import React, { MouseEventHandler, useCallback } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'

interface Props {
  includesFlights: boolean;
  onCtaClick: (shouldKeepBrowsing: boolean) => void;
}

function PropertyAvailableRateOptionCtas({ includesFlights, onCtaClick }: Props) {
  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(event => {
    const shouldKeepBrowsing = !!event.currentTarget.dataset.keepBrowsing
    onCtaClick(shouldKeepBrowsing)
  }, [onCtaClick])

  return <>
    {!includesFlights && <TextButton
      onClick={onClick}
      kind="primary"
      size="large"
    >
      Book now
    </TextButton>}
    {includesFlights && <TextButton
      onClick={onClick}
      kind="primary"
      size="large"
    >
      Select package
    </TextButton>}
    {!includesFlights && <TextButton
      onClick={onClick}
      kind="secondary"
      startIcon={<LineShoppingCartIcon />}
      size="large"
      data-keep-browsing
    >
      Add to cart
    </TextButton>}
  </>
}

export default React.memo(PropertyAvailableRateOptionCtas)
